import React from 'react';
import PropTypes from 'prop-types';
import { clsHeaderIcon } from '../helpers/TableHelpers';

const TABLE_HEADER = {
  1: 'id',
  2: 'surveys.invited_at',
  3: 'surveys.teacher_finished_at',
  4: 'surveys.parent_finished_at',
  5: 'surveys.follow_up_status',
}

const ASQHeaderSort = ({ children, cls = '', idx, meta, onSortChange }) => {
  const key = TABLE_HEADER[idx];
  const onClick = key && onSortChange;

  return (
    <div data-sort={key} className={`o-rtable__cell ${cls}`} onClick={onClick}>
      <span data-sort={key} className='o-table-header--sort'>
        {children}<i data-sort={key} className={clsHeaderIcon(key, meta)}></i>
      </span>
    </div>
  )
}

ASQHeaderSort.propTypes = {
  children: PropTypes.node,
  cls: PropTypes.string,
  idx: PropTypes.number.isRequired,
  meta: PropTypes.object.isRequired,
  onSortChange: PropTypes.func.isRequired,
};

export default ASQHeaderSort;
